import React from 'react'
import { makeStyles } from '@mui/styles'
import { getRawMessage } from '../../../locale'

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(1.5, 0),
    [theme.breakpoints.down('sm')]: {
      flexBasis: '100% !important',
      width: '100% !important',
    },
    '&>*': {
      width: '100%',
    },
  },
  error: {
    width: '100%',
    padding: '5px 0',
    color: theme.palette.error.main,
    fontSize: '12px',
    whiteSpace: 'pre-wrap',
  },
}))

export default function FieldWrapper({ error, fullWidth = true, children }) {
  const classes = useStyles()

  const showErrors = () => {
    // field errors should be array or string. object is not a valid format
    if (Array.isArray(error)) return error.map((err) => `${err}\n`)
    if (typeof error === 'string') return error
    return getRawMessage('general.field.error.message')
  }

  return (
    <div
      className={classes.root}
      style={
        fullWidth ? { flexBasis: '100%' } : { flexBasis: '48%', width: '48%' }
      }
    >
      {children}
      <div className={classes.error}>{error ? showErrors() : null}</div>
    </div>
  )
}
